import React, { useState } from 'react';

export const FullDataContext = React.createContext({});

const contexts = {
    fileInfo: {
        initialValue: 'There is no uploaded/removed file info yet',
        context: React.createContext({})
    },
};

const getContext = (propName) => contexts[propName].context;

const getInitialValue = propName => contexts[propName].initialValue;

const ContextProvider = (props) => {

    const { propName, propUpdater, children } = props;

    const [value, updater] = useState(contexts[propName].initialValue);

    const Context = getContext(propName);

    return (
        <Context.Provider
            value={[
                value,
                propUpdater ? () => propUpdater(value) : updater
            ]}
        >
            { children }
        </Context.Provider>
    );
};

export { ContextProvider, getContext, getInitialValue };